import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/quicken_income",
  name: "quicken_income",
  component: function component() {
    return import("../../../views/others/speed_up_index.vue");
  },
  meta: {
    foot: true,
    title: "加速收益分红"
  }
}];